<template>
  <div>
    <div class="loader-outer">
      <div class="loader">
        <span class="dot dot-1"></span>
        <span class="dot dot-2"></span>
        <span class="dot dot-3"></span>
        <span class="dot dot-4"></span>
      </div>
    </div>
    <div id="particles-bg">
      <particles-bg color="#f7941e" num="7" type="cobweb" :bg="true" />
    </div>
    <div id="aboutUs">
      <!-- <span v-if="index == 0"> -->
      <div id="content">
        <Content
            :title="contents.find(content => content.id_content === 19)?.title"
            :description="contents.find(content => content.id_content === 19)?.description"
        ></Content>
      </div>
      <img class="circle" src="../assets/circle.svg" alt=""/>
      <!-- <span v-if="index == 0"> -->
      <div id="content">
        <Content
            :title="contents.find(content => content.id_content === 21)?.title"
            :description="contents.find(content => content.id_content === 21)?.description"
        ></Content>
      </div>
      <img class="circle" src="../assets/circle.svg" alt=""/>

      <h1 id="valuesTitle">{{ contents.find(content => content.id_content === 50)?.title }}</h1>
      <div id="values" class="row col-sm-12">
        <div class="col-sm-4 d-flex justify-content-center">
          <Cards
              :title="contents.find(content => content.id_content === 51)?.title"
              :msg="contents.find(content => content.id_content === 51)?.description"
            :link="require('../assets/comunidade.svg')"
          >
            /></Cards
          >
        </div>
        <div class="col-sm-4 d-flex justify-content-center text-center">
          <Cards
              :title="contents.find(content => content.id_content === 52)?.title"
              :msg="contents.find(content => content.id_content === 52)?.description"
            :link="require('../assets/respeito.svg')"
          ></Cards>
        </div>
        <div class="col-sm-4 d-flex justify-content-center text-center">
          <Cards
              :title="contents.find(content => content.id_content === 53)?.title"
              :msg="contents.find(content => content.id_content === 53)?.description"
            :link="require('../assets/transparencia.svg')"
          ></Cards>
        </div>
        <div class="col-sm-6 d-flex justify-content-center text-center">
          <Cards
              :title="contents.find(content => content.id_content === 54)?.title"
              :msg="contents.find(content => content.id_content === 54)?.description"
            :link="require('../assets/equipa.svg')"
          >
            /></Cards
          >
        </div>
        <div class="col-sm-6 d-flex justify-content-center text-center">
          <Cards
              :title="contents.find(content => content.id_content === 55)?.title"
              :msg="contents.find(content => content.id_content === 55)?.description"
            :link="require('../assets/inovacao.svg')"
          ></Cards>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import { ParticlesBg } from "particles-bg-vue";
import Cards from "@/components/Cards";
import Content from "@/components/Content";
import Footer from "../components/Footer";

import Vue from "vue";
import VueAnimateOnScroll from "vue-animate-onscroll";
import { mapGetters } from "vuex";

Vue.use(VueAnimateOnScroll);

export default {
  name: "AboutUs",
  components: {
    Cards,
    Content,
    ParticlesBg,
    Footer,
  },
  data: function() {
    return {
      contents: [],
      values: [],
    };
  },
  mounted() {
    this.getAllContent();
  },
  methods: {
    async getAllContent() {
      this.contents = [];
      try {
        await this.$store.dispatch("fetchContent");
        let lang = localStorage.getItem("lang") ? localStorage.getItem("lang") : "pt";
        for (let i = 0; i < this.getContent.data.length; i++) {
          if (this.getContent.data[i].page === 3) {
            let content = {
              id_content: this.getContent.data[i].id_content,
              title: lang === "pt" ? this.getContent.data[i].title : this.getContent.data[i].title_en,
              description: lang === "pt" ? this.getContent.data[i].description : this.getContent.data[i].description_en,
              img: this.img,
            };
            this.contents.push(content);
          }
        }
      } catch (err) {
        this.$router.push({ name: "Error" });
      }
    },
  },
  computed: { ...mapGetters(["getContent"]) },
};
</script>
<style scoped>
h1 {
  font-size: 60px;
  text-align: center;
  font-family: "Barlow Medium", sans-serif;
}
.circle {
  padding-top: 50px;
  padding-bottom: 50px;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.values {
  padding: 50px 200px 50px 200px;
  text-align: center;
}
#content {
  padding-top: 50px;
}
#values {
  padding-top: 50px;
}
#valuesTitle {
  padding-top: 50px;
}
.row {
  padding-bottom: 50px;
}
#img {
  width: 100%;
  height: 200px;
  object-fit: none;
}

#particles-bg {
  position: fixed;
  /* fill the entire page */
  width: 100%;
  height: 100%;
  /* remove the space along the edges */
  margin: 0;
  padding: 0;
  /* position it to start at the top of the page */
  top: 0;
  /* put it behind other content */
  z-index: -1;
}
@media (max-width: 1000px) {
  h1 {
    text-align: center;
  }
  .circle {
    padding: 50px;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
  #content {
    padding: 50px 10px 0px 10px;
    text-align: center;
  }

  .values {
    padding: 50px 10px 50px 10px;
    text-align: center;
  }
  .values h1 {
    padding-bottom: 50px;
  }
  .row {
    padding-bottom: 50px;
    padding-left: 50px;
  }
  #img {
    width: 100%;
    height: 100px;
  }

  #particles-bg {
    position: fixed;
    /* fill the entire page */
    width: 100%;
    height: 100%;
    /* remove the space along the edges */
    margin: 0;
    padding: 0;
    /* position it to start at the top of the page */
    top: 0;
    /* put it behind other content */
    z-index: -1;
  }
}
</style>
